export default __webpack_public_path__ + "static/custom-60fc5db112e44fa4818c6aa89f0f2033.png";